<app-header></app-header>
<app-lateral-buttons></app-lateral-buttons>
<!--====================================================
                     HOME
======================================================-->
<section id="home">
  <div id="carousel" class="carousel slide carousel-fade" data-ride="carousel">
    <!-- Carousel items -->
    <div class="carousel-inner">
      <div class="carousel-item active slides">
        <div class="overlay"></div>
        <div class="slide-1"></div>
        <div class="hero">
          <h3 class="wow fadeInUp">
            <h1>
              <img src="assets/img/logo-banner.png" alt="logo" /><br />
              <span
                ><a
                  href=""
                  class="typewrite"
                  data-period="2000"
                  data-type='[ " Eficiencia", " Calidad", " Confianza"]'
                >
                  <span class="wrap"></span></a
              ></span>
            </h1>
            <button
              class="btn btn-general btn-green"
              role="button"
              (click)="router.navigate(['/contacto'])"
            >
              Contactanos
            </button>
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>

<!--====================================================
                    ABOUT
======================================================-->
<section id="about" class="about">
  <div class="container">
    <div class="row title-bar">
      <div class="col-md-12">
        <h1 class="wow fadeInUp"> No generamos crédito de libre inversión</h1>
        <div class="heading-border"></div>
      </div>
    </div>
  </div>

<div id="bannerMerquellantas" class="carousel slide" data-ride="carousel">
  <ol class="carousel-indicators">
    <li
      data-target="#bannerMerquellantas"
      data-slide-to="0"
      class="active"
    ></li>
    <li data-target="#bannerMerquellantas" data-slide-to="1"></li>
  </ol>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img
        class="d-block w-100"
        src="assets/img/merque1.jpg"
        alt="First slide"
      />
    </div>
    <div class="carousel-item">
      <img
        class="d-block w-100"
        src="assets/img/merque2.jpg"
        alt="Second slide"
      />
    </div>
  </div>
</div>
<!--====================================================
                    ABOUT
======================================================-->
<section id="about" class="about">
  <div class="container">
    <div class="row title-bar">
      <div class="col-md-12">
        <h1 class="wow fadeInUp">Nos comprometemos a crecer juntos</h1>
        <div class="heading-border"></div>
        <p class="wow fadeInUp" data-wow-delay="0.4s">
          Mundo Financiera es una empresa innovadora, que nació para acompañarte
          en el logro de tus metas, brindando soluciones de crédito con
          tecnología de punta.
          <br />
          Prestamos un servicio con todas las garantías de <b>calidad</b>, para
          darte la <b>confianza</b> de que somos tú mejor aliado, siempre
          pensando en ser <b>eficientes</b> para que las ideas y necesidades de
          nuestros clientes sean atendidas con prontitud.
        </p>
      </div>
    </div>
  </div>
  <!-- About right side withBG parallax -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 bg-starship">
        <div class="about-content-box wow fadeInUp" data-wow-delay="0.3s">
          <i class="fa fa-clock-o"></i>
          <h5>Eficiencia</h5>
          <p class="desc">
            Trabajamos para que todos nuestros procesos sean ágiles y oportunos,
            siempre pensando en que tus necesidades no dan espera
          </p>
        </div>
      </div>
      <div class="col-md-4 bg-chathams">
        <div class="about-content-box wow fadeInUp" data-wow-delay="0.5s">
          <i class="fa fa-check-circle"></i>
          <h5>Calidad</h5>
          <p class="desc">
            Nuestros procesos son simples y seguros, trabajamos con todos los
            estándares de permitidos, para que tus datos y tus pagos sean 100%
            asegurados.
          </p>
        </div>
      </div>
      <div class="col-md-4 bg-matisse">
        <div class="about-content-box wow fadeInUp" data-wow-delay="0.7s">
          <i class="fa fa-handshake-o"></i>
          <h5>Confianza</h5>
          <p class="desc">
            Mundo Financiera confía y cree en ti, brindamos todas las garantías
            para construir confianza y crezcamos juntos.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!--====================================================
                    OFFER
======================================================-->
<!-- <section id="comp-offer">
  <div class="container-fluid">
    <div class="row">
      <div
        class="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
        data-wow-delay="0.2s"
      >
        <h2>Nuestros servicios</h2>
        <div class="heading-border-light"></div> -->
        <!--<button class="btn btn-general btn-green" role="button">See Curren Offers</button>-->
        <!--<button
          class="btn btn-general btn-white"
          role="button"
          (click)="router.navigate(['/contacto'])"
        >
          Contactanos
        </button>
      </div>
      <div
        class="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
        data-wow-delay="0.4s"
      >
        <div class="desc-comp-offer-cont">
          <div class="thumbnail-blogs">
            <div class="caption">
              <i class="fa fa-chain"></i>
            </div>
            <img
              src="assets/img/news/news-11.jpg"
              class="img-fluid"
              alt="..."
            />
          </div>
          <h3>Crédito Directo</h3>
          <p class="desc">
            Con nosotros te vas a saltar las largas esperas que poseen los
            préstamos tradicionales. Adiós a las colas, entrevistas y papeleo
            eterno.
          </p>
          <a href="#"><i class="fa fa-arrow-circle-o-right"></i> Leer más</a>
        </div>
      </div>
      <div
        class="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
        data-wow-delay="0.6s"
      >
        <div class="desc-comp-offer-cont">
          <div class="thumbnail-blogs">
            <div class="caption">
              <i class="fa fa-chain"></i>
            </div>
            <img
              src="assets/img/news/news-13.jpg"
              class="img-fluid"
              alt="..."
            />
          </div>
          <h3>Crédito Educativo</h3>
          <p class="desc">
            Nos ajustamos a tus capacidades de pago para que puedas mantener
            siempre tu meta de terminar tus estudios.
          </p>
          <a href="#"><i class="fa fa-arrow-circle-o-right"></i> Leer más</a>
        </div>
      </div>
      <div
        class="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
        data-wow-delay="0.8s"
      >
        <div class="desc-comp-offer-cont">
          <div class="thumbnail-blogs">
            <div class="caption">
              <i class="fa fa-chain"></i>
            </div>
            <img
              src="assets/img/news/news-14.jpg"
              class="img-fluid"
              alt="..."
            />
          </div>
          <h3>Crédito Automotriz</h3>
          <p class="desc">
            Si tú sueño es adquirir un vehículo, cuenta con nosotros, aquí
            estamos para ayudarte y verte cumplir esta meta.
          </p>
          <a href="#"><i class="fa fa-arrow-circle-o-right"></i> Learn More</a>
        </div>
      </div>
    </div>
  </div>
</section> -->

<!--====================================================
                 WHAT WE DO
======================================================-->
<!--<section class="what-we-do bg-gradiant">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <h3>What we Do</h3>
        <div class="heading-border-light"></div>
        <p class="desc">We partner with clients to put recommendations into practice. </p>
      </div>
      <div class="col-md-9">
        <div class="row">
          <div class="col-md-4  col-sm-6">
            <div class="what-we-desc">
              <i class="fa fa-briefcase"></i>
              <h6>Workspace</h6>
              <p class="desc">Contrary to popular belief, Lorem Ipsum is not simply random text. </p>
            </div>
          </div>
          <div class="col-md-4  col-sm-6">
            <div class="what-we-desc">
              <i class="fa fa-shopping-bag"></i>
              <h6>Storefront</h6>
              <p class="desc">Contrary to popular belief, Lorem Ipsum is not simply random text. </p>
            </div>
          </div>
          <div class="col-md-4  col-sm-6">
            <div class="what-we-desc">
              <i class="fa fa-building-o"></i>
              <h6>Apartments</h6>
              <p class="desc">Contrary to popular belief, Lorem Ipsum is not simply random text. </p>
            </div>
          </div>
          <div class="col-md-4  col-sm-6">
            <div class="what-we-desc">
              <i class="fa fa-bed"></i>
              <h6>Hotels</h6>
              <p class="desc">Contrary to popular belief, Lorem Ipsum is not simply random text. </p>
            </div>
          </div>
          <div class="col-md-4  col-sm-6">
            <div class="what-we-desc">
              <i class="fa fa-hourglass-2"></i>
              <h6>Concept</h6>
              <p class="desc">Contrary to popular belief, Lorem Ipsum is not simply random text. </p>
            </div>
          </div>
          <div class="col-md-4  col-sm-6">
            <div class="what-we-desc">
              <i class="fa fa-cutlery"></i>
              <h6>Restaurant</h6>
              <p class="desc">Contrary to popular belief, Lorem Ipsum is not simply random text. </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<!--====================================================
                  STORY
======================================================-->
<!--<section id="story">
    <div class="container">
      <div class="row title-bar">
        <div class="col-md-12">
          <h1 class="wow fadeInUp">Our Success Tranformation Story</h1>
          <div class="heading-border"></div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row" >
        <div class="col-md-6" >
          <div class="story-himg" >
            <img src="img/image-4.jpg" class="img-fluid" alt="">
          </div>
        </div>
        <div class="col-md-6">
          <div class="story-desc">
            <h3>How to grow world with Us</h3>
            <div class="heading-border-light"></div>
            <p>Everyone defines success differently – as much as there are people, there are different opinions. Number one in our priority list is the success of our students, alumni and their employers. We work hard in the name of the success of our alumni – being among the best and holding the high employment rate. Many desktop publishing packages and web page editors now use Lorem Ipsum.. </p>
            <p>You can find some thoughts on success from our students and alumni here – every story is unique, but this is what success is. Everybody sees it differently. Many desktop publishing packages and web page editors now use Lorem Ipsum.</p>
            <p class="text-right" style="font-style: italic; font-weight: 700;"><a href="#">Businessbox</a></p>
            <div class="title-but"><button class="btn btn-general btn-green" role="button">Read More</button></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
          <div class="story-descb">
              <img src="img/news/news-10.jpg" class="img-fluid" alt="...">
              <h6>Virtual training systems</h6>
              <p>Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.</p>
              <a href="#"><i class="fa fa-arrow-circle-o-right"></i> Read More</a>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
          <div class="story-descb">
              <img src="img/news/news-2.jpg" class="img-fluid" alt="...">
              <h6>Design planning</h6>
              <p>Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.</p>
              <a href=""><i class="fa fa-arrow-circle-o-right"></i> Read More</a>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="story-descb">
              <img src="img/news/news-8.jpg" class="img-fluid" alt="...">
              <h6>Remote condition monitoring</h6>
              <p>Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.</p>
              <a href=""><i class="fa fa-arrow-circle-o-right"></i> Read More</a>
          </div>
        </div>
      </div>
    </div>
</section>-->

<!--====================================================
              COMPANY THOUGHT
======================================================-->
<div class="overlay-thought"></div>
<section id="thought" class="bg-parallax thought-bg">
  <div class="container">
    <div id="carouselThought" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li
          data-target="#carouselThought"
          data-slide-to="0"
          class="active"
        ></li>
        <li data-target="#carouselThought" data-slide-to="1"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <div class="heading-border bg-white"></div>
          <p class="wow fadeInUp" data-wow-delay="0.4s">
            Mundo Financiera surgio como una idea para cambiar la vida de las
            personas, queremos ver metas cumplidas, queremos brindar un servicio
            ágil y de calidad, queremos ser parte de tú vida.
          </p>
          <h6>Jhon Gaviria</h6>
        </div>
        <div class="carousel-item">
          <div class="heading-border bg-white"></div>
          <p>
            Nuestra empresa está aquí para ser un apoyo. Mundo Financiara es una
            compañía pensada en un mundo de personas y empresas, facilitando
            soluciones de crédito en transacciones comerciales, teniendo siempre
            como prioridad nuestros clientes.
          </p>
          <h6>Jonnatan Sánchez</h6>
        </div>
      </div>
    </div>
  </div>
</section>
<app-contacto></app-contacto>
<app-footer></app-footer>
<!--Global JavaScript -->
<script src="../../../assets/js/jquery/jquery.min.js"></script>
<script src="../../../assets/js/popper/popper.min.js"></script>
<script src="../../../assets/js/bootstrap/bootstrap.min.js"></script>
<script src="../../../assets/js/wow/wow.min.js"></script>
<script src="../../../assets/js/owl-carousel/owl.carousel.min.js"></script>

<!-- Plugin JavaScript -->
<script src="../../../assets/js/jquery-easing/jquery.easing.min.js"></script>
<script src="../../../assets/js/custom.js"></script>
